module.exports = __webpack_public_path__ + "static/img/CRW_6230-02temp-1080p.6aa964e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio1/CRW_6230-02temp-1080p.jpg
// module id = LpxK
// module chunks = 0